<template>
  <v-app>
    <core-app-bar />
    <core-drawer />
    <v-sheet height="75" />
    <core-banner-bar />
    <core-view />
    <core-footer />
  </v-app>
</template>

<script>
import CoreAppBar from "./components/core/AppBar.vue";
import CoreFooter from "./components/core/Footer.vue";
import CoreDrawer from "./components/core/Drawer.vue";
import CoreView from "./components/core/View.vue";
import CoreBannerBar from "./components/core/BannerBar.vue";

export default {
  name: "App",

  components: {
    CoreAppBar,
    CoreFooter,
    CoreDrawer,
    CoreView,
    CoreBannerBar,
  },
};
</script>
